import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
const columns = [{
  title: 'Thuisbatterij',
  links: [{
    label: 'Kluis 5, 10 en 15',
    to: '/thuisbatterij'
  }, {
    label: 'Vergelijk modellen',
    to: '/thuisbatterij#vergelijk'
  }, {
    label: 'De app',
    to: '/#app'
  }, {
    label: 'Salderingsregeling',
    to: '/#saldering'
  }]
}, {
  title: 'Advies',
  links: [{
    label: 'Gratis huisscan',
    to: '/scan'
  }, {
    label: 'Werkwijze',
    to: '/#werkwijze'
  }, {
    label: 'Veelgestelde vragen',
    to: '/#faq'
  }]
}, {
  title: 'Stroomkluis',
  links: [{
    label: 'Over ons',
    to: '/over-ons'
  }, {
    label: 'Contact',
    to: '/contact'
  }, {
    label: 'Werken bij',
    to: '/over-ons'
  }]
}];
export function Footer() {
  return <footer className="bg-forest-deep text-canvas" data-id="element-316" data-mp="3e1uit1nn7qt5">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10" data-id="element-317" data-mp="3e4qfkmnr89g0">
        <div className="grid gap-12 border-b border-canvas/10 py-16 lg:grid-cols-[1.5fr_1fr_1fr_1fr]" data-id="element-318" data-mp="394b4k1qy3e17">
          <div data-id="element-319" data-mp="2kbtjywkdwem9">
            <Logo tone="light" data-id="element-320" data-mp="2kb0cftdlpl32" />
            <p className="mt-5 max-w-xs text-[15px] leading-relaxed text-canvas/65" data-id="element-321" data-mp="2p4cxxumzhbrl">
              Thuisbatterijen, advies en installatie door eigen vakmensen. Actief in heel Nederland sinds 2016.
            </p>
            <address className="mt-6 space-y-1.5 text-[15px] not-italic text-canvas/85" data-id="element-322" data-mp="2gaq6uhtq0woq">
              <p data-id="element-323" data-mp="340kiwx67uh7x">Energieweg 12, 3905 AB Veenendaal</p>
              <p data-id="element-324" data-mp="33yzkgwgs6e4s">
                <a href="tel:0850000000" className="hover:text-volt" data-id="element-325" data-mp="382p6pf9zgjmn">085 – 000 00 00</a> ·{' '}
                <a href="mailto:advies@stroomkluis.nl" className="hover:text-volt" data-id="element-326" data-mp="380cp53850ba4">advies@stroomkluis.nl</a>
              </p>
            </address>
          </div>
          {columns.map(c => <nav key={c.title} aria-label={c.title} data-id="element-327" data-mp="2z3u2u9uevlmi">
              <h2 className="text-sm font-medium text-canvas/50" data-id="element-328" data-mp="1impvlsmt0k4d">{c.title}</h2>
              <ul className="mt-4 space-y-3" data-id="element-329" data-mp="1nndjw6jnemuw">
                {c.links.map(l => <li key={l.label} data-id="element-330" data-mp="13khma0t178u9">
                    <Link to={l.to} className="text-[15px] text-canvas/85 transition-colors duration-150 hover:text-volt" data-id="element-331" data-mp="13jg0p2ee33ya">
                      {l.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="pt-12" aria-hidden="true" data-id="element-332" data-mp="ps9smhx1nxzs">
          <svg viewBox="0 0 1000 150" className="block h-auto w-full select-none" preserveAspectRatio="xMidYMid meet" data-id="element-333" data-mp="pri75zx5vgn8">
            <text x="0" y="130" textLength="1000" lengthAdjust="spacingAndGlyphs" className="fill-forest font-display" style={{
            fontSize: 176,
            fontWeight: 600,
            letterSpacing: '-0.04em'
          }} data-id="element-334" data-mp="fvetpxwuzvkz">
              stroomkluis
            </text>
          </svg>
        </div>

        <div className="flex flex-col gap-2 py-6 text-sm text-canvas/50 sm:flex-row sm:justify-between" data-id="element-335" data-mp="266t7r1u5nxxd">
          <p data-id="element-336" data-mp="216ey5fcwofx8">© 2026 Stroomkluis B.V. · KvK 00000000 · InstallQ erkend</p>
          <p data-id="element-337" data-mp="28r7qj6ygd3rr">Demo-omgeving · berekeningen zijn indicatief</p>
        </div>
      </div>
    </footer>;
}